module.exports = __webpack_public_path__ + "img/recommend.5e62eb0a.jpg";